var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"policy-item",on:{"click":function($event){return _vm.toDetails(_vm.policy)}}},[_c('div',{staticClass:"policy-item-title"},[_vm._v(_vm._s(_vm.policy.newsTitle))]),_vm._v(" "),_c('div',{staticClass:"news-item-type"},_vm._l((_vm.policy.tag),function(tag){return _c('span',{key:tag},[_vm._v(_vm._s(tag))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ed6e40c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/policy-item.vue
// module id = null
// module chunks = 